<template>
    <v-overlay v-model="localAutoForwardRuleDialog">
        <v-dialog v-model="localAutoForwardRuleDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
        <v-card>
            <v-toolbar class="bg-white">
                <v-card-title class="p-0">{{ $t("res_Title_AutoForwardRules") }}</v-card-title>
                <v-spacer></v-spacer>
                <v-btn class="close-btn light-btn" icon dark @click="localAutoForwardRuleDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="d-flex flex-column overflow-auto h-100">
                <div class="p-4 flex-grow-1 overflow-auto">
                    <div class="d-flex flex-column gap-2 mb-4">
                        <label>{{ $t("res_Label_ForwardTo")}}<span> *</span></label>
                        <StructureUserSelector 
                                :showInternalUsers="false" :showExternalUsers="false"
                                :showInternalStructures="true"
                                :showExternalStructures="false"
                                :isMultiple="false" :selectedStructureUser="auto_forward_rule_obj.structure"
                                @structureUserSelectChanged="forwardToChanged" :addressBook_header="$t('res_Label_SelectStructure')">
                        </StructureUserSelector>
                    </div>
                    <div class="d-flex flex-column gap-2">
                        <label>{{ $t("res_Label_Exceptions")}}</label>
                        <StructureUserSelector 
                                :showInternalUsers="true" :showExternalUsers="false"
                                :showInternalStructures="false"
                                :showExternalStructures="false"
                                :isMultiple="true" :selectedStructureUsersList="auto_forward_rule_obj.exceptionStructure"
                                @structureUserSelectChanged="exceptionToChanged" :addressBook_header="$t('res_Label_SelectExceptionUsers')">
                        </StructureUserSelector>
                    </div>
                </div>
            </div> 
            <v-card-actions class="top-shadow gap-3">
                <v-btn class="primary flex-1" color="primary" @click="addNewAutoForwardRule">{{ $t("res_ButtonText_Save") }}</v-btn>
                <v-btn class="light-blue flex-1" color="light-blue" @click="deleteAutoForwardRule">{{ $t("res_ButtonText_Reset")}}</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-overlay>
  </template>
  
  <script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from './StructureUserSelector.vue'
  
    export default {
      name: 'AutoForward',
      components: { Multiselect, StructureUserSelector },
      data() {
        return {
          localAutoForwardRuleDialog: this.autoForwardRuleDialog,
          structures: [],
          exceptionStructures: [],
          loading: false,
          openDialogFromManageStructer: false,
          snackbar_show: false,
          snackbar_text: '',
          auto_forward_rule_obj: {
            exceptionStructure: [],
            structure: null,
          },
          autoForwardId: 0,
        };
      },
      props: {
        structureId: Number,
        UserId: Number,
        fromStructureId: Number,
        autoForwardRuleDialog: Boolean,
        forUser: Boolean,
        userId: Number
      },
      watch: {
        autoForwardRuleDialog(val) {
          this.localAutoForwardRuleDialog = val;
        },
        localAutoForwardRuleDialog(val) {
          this.$emit('update:autoForwardRuleDialog', val);
        },
        structureId(newVal, oldVal) {
          if (newVal != oldVal) {
            this.auto_forward_rule_obj = {
              exceptionStructure: [],
              structure: null,
            };
            if(this.forUser)
                this.getAutoForwardForUser();
            else
                this.getAutoForward();
          }
        },
        fromStructureId(newVal, oldVal) {
          if (newVal != oldVal) {
            if(this.forUser)
                this.getAutoForwardForUser();
            else
                this.getAutoForward();
          }
        },
        auto_forward_rule_obj(newVal, oldVal) {
          console.log(this.auto_forward_rule_obj);
        }
      },
    methods:
    {
        forwardToChanged(item) {
            this.auto_forward_rule_obj.structure = item;
        },
        exceptionToChanged(items) {
            items = items.filter(x => x.id != "0")
            console.log(items);
            this.auto_forward_rule_obj.exceptionStructure = utils.handleFirstElement(items);
        },
        addNewAutoForwardRule() 
        {
            if(this.auto_forward_rule_obj.structure != null && this.auto_forward_rule_obj.structure != undefined && 
                this.auto_forward_rule_obj.structure.id != 0)
            {
                var selectedExceptionUsers = ''
                this.auto_forward_rule_obj.exceptionStructure.forEach((user) => {
                    selectedExceptionUsers += user.id + ','
                });
                selectedExceptionUsers = selectedExceptionUsers.replace(/,\s*$/, "");

                axios.post(constants.baseApiUrl + 'AutoForward/AddNewAutoForwardRule', {
                            FromId: this.UserId,
                        ToId: this.auto_forward_rule_obj.structure.id,
                        ExceptionIds: selectedExceptionUsers,
                        CreatedBy: 1,
                        Type: 'To',
                        FromStructureId:this.structureId,
                        ToStructureId:this.auto_forward_rule_obj.structure.id
                    })
                    .then(res => {
                        if(res != null && res.data !== false) {
                            this.autoForwardId = res.data;
                            window.showAlert('res_Msgs_AutoForwardRuleAdded', 'success')
                        } else {
                            window.showAlert('res_Msgs_AutoForwardRuleDuplicate', 'error')
                        }
                    })
                    .catch(err => console.warn(err))
            }
            else
            {
                window.showAlert('res_Msgs_FillRequired', 'warning')
            }
        },
        deleteAutoForwardRule() {
            axios.post(constants.baseApiUrl + "AutoForward/DeleteAutoForwardRule?autoForwardId=" + this.autoForwardId)
                .then(res => 
                {
                    if (res.data != null && res.data == true) {
                        this.auto_forward_rule_obj = {
                            exceptionStructure: [],
                            structure: null,
                        }
                        window.showAlert('res_Msgs_AutoForwardRuleDeleted', 'success');
                        this.autoForwardId = 0;
                    }                   
                })
                .catch(err => console.warn(err))
        },
        asyncFindForwardStructure(query)
            {
            var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=false&search=';

            axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                .then(res => this.structures = res.data)
                .catch(err => console.warn(err))
        },
        asyncFindExceptionUser(query) 
        {
            var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';

            axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                .then(res => this.exceptionStructures = res.data)
                .catch(err => console.warn(err))
        },
        getAutoForward() 
        {
            this.fromStructureId;
            this.autoForwardId = 0;
            axios.post(constants.baseApiUrl + "AutoForward/GetAutoForwardRuleForStructure?structureId=" + this.structureId)
                .then(res => 
                {
                    if (res.data != null && res.data != "") 
                    {
                        this.autoForwardId = res.data.id;

                        var arrayofExceptions = res.data.exceptionIds.split(',')

                        this.auto_forward_rule_obj.structure = { id: res.data.toStructureId, name: res.data.to };
                        this.auto_forward_rule_obj.exceptionStructure = []

                        arrayofExceptions.forEach((element, index) => {
                            
                            if(element != '')
                            {
                                let myobj = {};
                                myobj.id = element;
                                myobj.name = res.data.exceptionNames.split(',')[index];

                                this.auto_forward_rule_obj.exceptionStructure.push(myobj);
                            }
                        });
                    }                   
                })
                .catch(err => console.warn(err))
        },
        CapitalizeFirstLetter(str)
        {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options)
        {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        }
    },
    watch: 
    {
        structureId: function (newVal, oldVal) 
        {
            if (newVal != oldVal) {
                this.auto_forward_rule_obj = {
                    exceptionStructure: [],
                    structure: null,
                }
                    this.getAutoForward();
            }
        },
        fromStructureId: function(newval,oldVal){
                if (newval != oldVal)
                    this.getAutoForward();
        },
        auto_forward_rule_obj: function(newval,oldVal){
            console.log(this.auto_forward_rule_obj);
        }
    },
    mounted() {
        this.autoForwardId = 0;
            this.getAutoForward();
    }
    }
</script>

<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->